import React from 'react'
import { BrowserRouter as Router, Route, Switch } from "react-router-dom"
import { AuthProvider } from "./context/AuthContext"
import App from './App'
import PortfolioPage from './PortfolioPage'
import NotFound from './NotFound'
import CreatePost from './CreatePost'
import Blog from './Blog'
import SignUp from './SignUp'
import SignIn from './SignIn'
import PostModal from './components/PostModals/PostModal'
import Profile from './Profile'
import FullProject from './components/FullProject'
import Store from './components/Store';
import AssetUpload from './components/AssetUpload';
import usePageTracking from './hooks/usePageTracking';
import ProductPage from './components/ProductPage'
import UploadProject from './UploadProject'

const App2 = () => {
  usePageTracking();

  const isLocalhost = window.location.hostname === 'localhost';

  return (
    <div className='App'>
      <Router>
        <AuthProvider>
          <Switch>
            <Route exact path="/" component={App} />
            <Route path="/portfolio" component={PortfolioPage} />
            <Route path="/blog" component={Blog} />
            <Route path="/blog/:id" component={PostModal} />
            <Route path="/createpost" component={CreatePost} />
            <Route path="/signup" component={SignUp} />
            <Route path="/signIn" component={SignIn} />
            <Route path="/profile" component={Profile} />
            <Route path="/fullProject/:id" component={FullProject} />
            <Route exact path="/store" component={Store} />
            <Route path="/store/:id" component={ProductPage} />
            <Route path="/upload" component={AssetUpload} />
            {isLocalhost && <Route path="/uploadProj" component={UploadProject} />}
            <Route component={NotFound} />
          </Switch>
        </AuthProvider>
      </Router>
    </div>
  )
}

export default App2
